<template>
  <div class='main-content sn-content'>
    <el-card class="box-card">
      <template>
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="padding: 0 30px;boxSizing: border-box;">
                <p v-html="scope.row.content"></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题"  align="center" ></el-table-column>
          <el-table-column prop="sendDate" label="发送时间"  align="center">
            <template slot-scope="scope">
              {{scope.row.sendDate | formatDate}}
            </template>
          </el-table-column>
        </el-table>
      </template>
      <PageComponent ref="pageInfo"></PageComponent>
    </el-card>

  </div>
</template>

<script>
  import {Message} from "element-ui";
  import PageComponent from '@/components/pageInfo/PageComponent'
  export default {
    components: {PageComponent},
    data() {
      return {
        tableData: [],
      }
    },
    created() {
    },
    methods: {

      getNoticeList: function () {
        var params = {};
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        params.userId = this.$store.state.user.userId;
        this.getRequest('/mncUserMsg/getList', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
    }
    ,
    mounted: function () {
      this.getNoticeList();
      this.$refs.pageInfo.initPagenator(this.getNotifyList, 10);
    }
    ,
    beforeDestroy() {

    }
  }
</script>

